import { render, staticRenderFns } from "./RadioGroup.vue?vue&type=template&id=7e9dadcf&scoped=true&"
import script from "./RadioGroup.vue?vue&type=script&lang=ts&"
export * from "./RadioGroup.vue?vue&type=script&lang=ts&"
import style0 from "./RadioGroup.vue?vue&type=style&index=0&id=7e9dadcf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9dadcf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
